export interface BrandConfig {
  companyName: string;
  productName: string;
  logoUrl: string;
  logoDarkUrl: string;
  faviconUrl: string;
  primaryColor: string;
  accentColor: string;
  surfaceBase: string;
  loginGradient: [string, string];
  emailHeaderColor: string;
  browserTitle: string;
  loginTitle: string;
  loginSubtitle: string;
  copyrightText: string;
  supportUrl?: string;
  primaryScale: {
    50: string;
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
    950: string;
  };
  shadowTint: string;
}

export const defaultBrand: BrandConfig = {
  companyName: 'TSI',
  productName: 'TSI',
  logoUrl: '/brand/logo.svg',
  logoDarkUrl: '/brand/logo-dark.svg',
  faviconUrl: '/brand/favicon.svg',
  primaryColor: '#006d77',
  accentColor: '#ffba27',
  surfaceBase: '#fbf9f5',
  loginGradient: ['#003a40', '#006d77'],
  emailHeaderColor: '#006d77',
  browserTitle: 'TSI — ניהול שירות',
  loginTitle: 'התחברות למערכת',
  loginSubtitle: 'מערכת ניהול שירותים',
  copyrightText: '© 2026 TSI',
  primaryScale: {
    50: '#eef8f9',
    100: '#d1eff2',
    200: '#a3dee5',
    300: '#6fcbd6',
    400: '#3bb5c3',
    500: '#1a9aaa',
    600: '#0d7b8a',
    700: '#006d77',
    800: '#00535b',
    900: '#003a40',
    950: '#001f23',
  },
  shadowTint: 'rgba(0, 83, 91, 0.04)',
};

export function loadBrandConfig(): BrandConfig {
  const env = import.meta.env;

  if (!env.VITE_BRAND_NAME) {
    return defaultBrand;
  }

  return {
    companyName: env.VITE_BRAND_COMPANY_NAME || env.VITE_BRAND_NAME || defaultBrand.companyName,
    productName: env.VITE_BRAND_DISPLAY_NAME || env.VITE_BRAND_NAME || defaultBrand.productName,
    logoUrl: env.VITE_BRAND_LOGO_URL || defaultBrand.logoUrl,
    logoDarkUrl: env.VITE_BRAND_LOGO_DARK_URL || defaultBrand.logoDarkUrl,
    faviconUrl: env.VITE_BRAND_FAVICON_URL || defaultBrand.faviconUrl,
    primaryColor: env.VITE_BRAND_PRIMARY_COLOR || defaultBrand.primaryColor,
    accentColor: env.VITE_BRAND_ACCENT_COLOR || defaultBrand.accentColor,
    surfaceBase: env.VITE_BRAND_SURFACE_BASE || defaultBrand.surfaceBase,
    loginGradient: env.VITE_BRAND_LOGIN_GRADIENT
      ? (env.VITE_BRAND_LOGIN_GRADIENT.split(',') as [string, string])
      : defaultBrand.loginGradient,
    emailHeaderColor: env.VITE_BRAND_EMAIL_COLOR || env.VITE_BRAND_PRIMARY_COLOR || defaultBrand.emailHeaderColor,
    browserTitle: env.VITE_BRAND_BROWSER_TITLE || defaultBrand.browserTitle,
    loginTitle: env.VITE_BRAND_LOGIN_TITLE || defaultBrand.loginTitle,
    loginSubtitle: env.VITE_BRAND_LOGIN_SUBTITLE || defaultBrand.loginSubtitle,
    copyrightText: env.VITE_BRAND_COPYRIGHT || defaultBrand.copyrightText,
    supportUrl: env.VITE_BRAND_SUPPORT_URL,
    primaryScale: env.VITE_BRAND_PRIMARY_SCALE
      ? JSON.parse(env.VITE_BRAND_PRIMARY_SCALE)
      : defaultBrand.primaryScale,
    shadowTint: env.VITE_BRAND_SHADOW_TINT || defaultBrand.shadowTint,
  };
}
